import React from 'react'
import styles from './styles'

import { withStyles } from '@material-ui/core/styles'
import { List, ListItem, Radio, Alert, Box } from '@material-ui/core'

import EditIcon from '@material-ui/icons/Edit'
import { CoreButton, CoreTextField } from 'src/components/core'
import { Icon } from '@iconify/react'

const StepTitle = props => {
  const {
    errorMessage,
    titleOptions,
    handleChange,
    selectedTitle,
    hasOwnTitle,
    handleTitleItemChange,
    inputFocus,
    addOwnTitle,
    sendOutlineRequest,
    selectedTitleIndex,
    classes,
  } = props
  return (
    <>
      <List className={classes.list}>
        {titleOptions &&
          titleOptions.map((titleOption, index) => (
            <ListItem
              key={'title_' + index}
              onClick={() => {
                handleChange(titleOption, index)
              }}
              className={classes.listItem}
            >
              <Radio
                checked={index === selectedTitleIndex}
                onChange={() => {
                  handleChange(titleOption, index)
                }}
                value={titleOption}
                name="radio-buttons"
                inputProps={{ 'aria-label': index }}
              />
              {/* <ListItemText id={titleOption} primary={titleOption} /> */}
              <CoreTextField
                id={'title_' + index}
                key={'title_input_' + index}
                defaultValue={titleOption}
                variant="standard"
                style={{ borderBottom: 0, width: '100%' }}
                autoFocus={hasOwnTitle}
                multiline
                onBlur={e => {
                  handleTitleItemChange(e, index)
                }}
                onChange={e => {
                  handleChange(e.target.value, index)
                }}
              />

              <EditIcon
                onClick={() => {
                  inputFocus('title_' + index)
                }}
                color="primary"
                fontSize="small"
              />
            </ListItem>
          ))}

        <CoreButton
          variant="text"
          size="small"
          onClick={() => addOwnTitle()}
          style={{
            display: hasOwnTitle == true ? 'none' : 'block',
            marginTop: 6,
          }}
        >
          Write your own title instead
        </CoreButton>
      </List>
      {errorMessage == true && (
        <>
          <Alert severity="warning">
            A problem occurred due to GPT-3. Please try again.
          </Alert>
          <Box style={{ marginBottom: '16px' }}></Box>
        </>
      )}
      <CoreButton
        variant="contained"
        onClick={() => sendOutlineRequest()}
        disabled={selectedTitle == undefined ? true : false}
      >
        Generate Outline <Icon icon="mage:coin-a" style={{ margin: '0 4px' }} />{' '}
        1
      </CoreButton>
    </>
  )
}

export default withStyles(styles)(StepTitle)
